module.exports = __webpack_public_path__ + "static/media/facebook-logo.524384ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook-logo.svg
// module id = 367
// module chunks = 0